import { FeedbackQuestion } from 'npo/pages/NPOFeedback/MakeEdits/api';
import { ApolloClient, gql } from 'apollo-boost';
import {
  DatabaseUserType,
  FeedbackSectionId,
} from 'donor/portal/pages/FeedbackDashboard/Feedback/utils';

export interface AllNpoReportQuestions {
  allNpoReportQuestions: {
    dbId: number;
    helpContent: string;
    nextQuestionId: number | null;
    questionType: FeedbackQuestion['questionType'];
    section: FeedbackSectionId;
    text: string;
  }[];
}

const allQuestionsQuery = gql`
  query {
    allNpoReportQuestions {
      edges {
        node {
          dbId
          text
          questionType
          section
          nextQuestionId
          helpContent
        }
      }
    }
  }
`;

export const getAllQuestions = (client: ApolloClient<object>) => {
  return client.query<AllNpoReportQuestions>({
    query: allQuestionsQuery,
    fetchPolicy: 'network-only',
  });
};

export interface AllUsers {
  allUsers: {
    id: string;
    dbId: number;
    userId: number;
    userType: DatabaseUserType;
    enabled: boolean;
    accountId: number;
    email: string;
    firstName: string;
    lastName: string;
    isLocked: boolean;
    title: string;
    phone: string;
    pronoun: string;
    isVerified: boolean;
  }[];
}

const findDonorByEmailQuery = gql`
  query allUsers($first: Int, $filters: [UsersFilter!]) {
    allUsers(first: $first, filters: { and: $filters }) {
      edges {
        node {
          id
          dbId
          userId
          userType
          enabled
          accountId
          email
          firstName
          lastName
          isLocked
          title
          phone
          pronoun
          isVerified
        }
      }
    }
  }
`;

export const findDonorByEmail = (
  client: ApolloClient<object>,
  email: string,
) => {
  return client.query<AllUsers>({
    query: findDonorByEmailQuery,
    variables: {
      first: 1,
      filters: [{ email }, { enabled: true }],
    },
    fetchPolicy: 'network-only',
  });
};
